module.exports = __webpack_public_path__ + "img/table-companies.0dbd29f7.svg";